import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-24 w-24 md:h-32 md:w-32 flex-none items-center flex" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "p-2 md:p-4 flex items-center w-full" }
const _hoisted_4 = { class: "text-left grow h-full relative" }
const _hoisted_5 = { class: "font-bold multiple-truncate text-sm sm:text-base my-2" }
const _hoisted_6 = { class: "text-gray-600 text-xs sm:text-sm absolute bottom-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "w-full h-24 md:h-32 flex rounded-lg shadow-sm my-2 overflow-hidden cursor-pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goGiftUrl(_ctx.exchangeResultWithGift)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.exchangeResultWithGift.gift.image_url,
        alt: "giftImage",
        class: "object-contain flex justify-center"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.exchangeResultWithGift.gift.name), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.receivedDateLabel || "当選日") + "：" + _toDisplayString(_ctx.exchangeResultWithGift.created_at), 1)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-6 flex-none" }, [
        _createElementVNode("svg", {
          width: "24",
          height: "25",
          viewBox: "0 0 24 25",
          xmlns: "http://www.w3.org/2000/svg",
          class: "ml-auto"
        }, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M16 12.3004C16 12.5284 15.923 12.7554 15.768 12.9404L10.768 18.9404C10.415 19.3644 9.78398 19.4224 9.35998 19.0684C8.93598 18.7154 8.87898 18.0854 9.23198 17.6604L13.708 12.2894L9.39298 6.92738C9.04698 6.49738 9.11498 5.86738 9.54498 5.52138C9.97498 5.17538 10.604 5.24338 10.951 5.67338L15.779 11.6734C15.926 11.8564 16 12.0784 16 12.3004Z",
            fill: "#5F6368"
          }),
          _createElementVNode("mask", {
            id: "mask0",
            "mask-type": "alpha",
            maskUnits: "userSpaceOnUse",
            x: "9",
            y: "5",
            width: "7",
            height: "15"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M16 12.3004C16 12.5284 15.923 12.7554 15.768 12.9404L10.768 18.9404C10.415 19.3644 9.78398 19.4224 9.35998 19.0684C8.93598 18.7154 8.87898 18.0854 9.23198 17.6604L13.708 12.2894L9.39298 6.92738C9.04698 6.49738 9.11498 5.86738 9.54498 5.52138C9.97498 5.17538 10.604 5.24338 10.951 5.67338L15.779 11.6734C15.926 11.8564 16 12.0784 16 12.3004Z",
              fill: "white"
            })
          ]),
          _createElementVNode("g", { mask: "url(#mask0)" }, [
            _createElementVNode("rect", {
              y: "24.3004",
              width: "24",
              height: "24",
              transform: "rotate(-90 0 24.3004)",
              fill: "#5F6368"
            })
          ])
        ])
      ], -1))
    ])
  ]))
}